import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { Button } from '../components/ui/button';
import { XCircle, ArrowLeft, HelpCircle } from 'lucide-react';

export const PaymentCancel = () => {
  const { t } = useLanguage();

  return (
    <div className="min-h-screen pt-24 pb-16 bg-slate-50 flex items-center justify-center" data-testid="payment-cancel-page">
      <div className="w-full max-w-lg px-6 text-center">
        <div className="w-20 h-20 bg-slate-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <XCircle className="w-10 h-10 text-slate-400" />
        </div>

        <h1 className="font-heading font-bold text-3xl text-slate-900 mb-4">
          Paiement annulé
        </h1>
        
        <p className="text-slate-600 text-lg mb-8">
          Vous avez annulé le processus de paiement. Aucun montant n'a été débité.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link to="/siteweb">
            <Button className="bg-primary hover:bg-primary-hover text-white rounded-full px-8 py-6 gap-2">
              <ArrowLeft className="w-5 h-5" />
              Retour aux offres
            </Button>
          </Link>
          <Link to="/appointment">
            <Button variant="outline" className="rounded-full px-8 py-6 gap-2 border-2">
              <HelpCircle className="w-5 h-5" />
              Besoin d'aide ?
            </Button>
          </Link>
        </div>

        <div className="mt-12 p-6 bg-white rounded-2xl shadow-sm">
          <h3 className="font-heading font-semibold text-lg text-slate-900 mb-4">
            Vous hésitez ?
          </h3>
          <p className="text-slate-600 text-sm mb-4">
            Prenez rendez-vous avec notre équipe pour discuter de vos besoins et trouver la solution adaptée.
          </p>
          <Link to="/appointment">
            <Button variant="outline" className="rounded-full">
              Prendre rendez-vous gratuit
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
};
